import editorialMedia from "./editorialMedia202609.json";
import editorialRelatedLinks from "./editorialRelatedLinks202609.json";

export function applyEditorialMedia(article) {
  const media = editorialMedia[article.path];
  const added = editorialRelatedLinks[article.path] || [];
  if (!media && !added.length) return article;
  const links = [...(article.relatedLinks || []), ...added];
  return {
    ...article,
    ...(media || {}),
    ...(media?.image ? { featuredImage: media.image } : {}),
    relatedLinks: links.filter((link, index, all) => all.findIndex((other) => other.path === link.path) === index),
  };
}
